/**
 * Renders a whole number of hours as descending abbreviated units, zero parts
 * omitted (30 → "1d 6h", 960 → "1mes 1sem 5d"). Used by the pipeline Kanban cards
 * and the Reports needs-attention cards to keep "hace …" labels readable past a day.
 *
 * month = 4 weeks, year = 12 months — a display approximation (a "month" is 28
 * days), harmless here since it only decorates a relative-time label. Abbreviations
 * are invariant regardless of count (2 months → "2mes"). Mirrors the backend digest
 * helper in `services/digest/digest-email.ts`; kept local (not shared) since it is a
 * tiny pure function and the two apps don't share this utility layer.
 */

// Descending, sized in hours.
const ELAPSED_UNITS: ReadonlyArray<readonly [string, number]> = [
  ["a", 8064],
  ["mes", 672],
  ["sem", 168],
  ["d", 24],
  ["h", 1],
];

export function formatElapsed(hours: number): string {
  if (!Number.isFinite(hours) || hours <= 0) return "0h";
  let remaining = Math.floor(hours);
  const parts: string[] = [];
  for (const [label, size] of ELAPSED_UNITS) {
    const count = Math.floor(remaining / size);
    if (count > 0) {
      parts.push(`${count}${label}`);
      remaining -= count * size;
    }
  }
  return parts.length > 0 ? parts.join(" ") : "0h";
}
